<template>
  <Nav :totalUsers="totalUsers" :totalTeams="totalTeams" />
  <div class="router-view-container">
    <Banner v-if="isHome" />
    <router-view ref="page"></router-view>
  </div>
  <Footer />
</template>

<script>
  import Banner from "./components/banner.vue";
  import Footer from "./components/footer.vue";
  import Nav from "./components/nav.vue";

  // window.onload = function () {
  //   document.addEventListener("touchstart", function (e) {
  //     if (e.touches.length > 1) {
  //       e.preventDefault();
  //     }
  //   });
  //   document.addEventListener("gesturestart", function (e) {
  //     e.preventDefault();
  //   });
  // };

  export default {
    name: "App",
    computed: {
      isHome() {
        return this.$route.path === "/";
      },
    },
    components: {
      Banner,
      Footer,
      Nav,
    },
    data() {
      return {
        isFixed: false,
        totalUsers: 0,
        totalTeams: 0,
      };
    },
    methods: {
      handleScroll() {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (window.screen.width <= 768) {
          const bannerHeight =
            document.querySelectorAll(".banner-container")[0].clientHeight ||
            document.querySelectorAll(".banner-container")[0].offsetHeight ||
            document.querySelectorAll(".banner-container")[0].scrollHeight;
          this.isFixed = scrollTop >= bannerHeight;
        } else {
          this.isFixed = scrollTop >= 562;
        }
      },
    },
    mounted() {
      // 监听滚动
      //   window.addEventListener("scroll", this.handleScroll, true);
    },
  };
</script>

<style lang="scss" scoped>
  #app {
    font-family: PingFang SC-Medium, PingFang SC, Avenir, Helvetica, Arial,
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }
</style>
